import { forwardRef } from 'react';

import { SvgStyled } from '@sternum/web/icons/icons.styles';
import { IconProps } from '@sternum/web/icons/icons.types';

export const StopIcon = forwardRef<SVGSVGElement, IconProps>(function StopIcon(
  { color = '', height = 18, width = 18, ...props },
  ref,
) {
  return (
    <SvgStyled
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      ref={ref}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.2143 4C12.5553 4 12.8823 4.1317 13.1234 4.36612C13.3645 4.60054 13.5 4.91848 13.5 5.25L13.5 12.75C13.5 13.0815 13.3645 13.3995 13.1234 13.6339C12.8823 13.8683 12.5553 14 12.2143 14L10.9286 14C10.5876 14 10.2606 13.8683 10.0194 13.6339C9.77832 13.3995 9.64286 13.0815 9.64286 12.75L9.64286 5.25C9.64286 4.91848 9.77832 4.60054 10.0194 4.36612C10.2606 4.1317 10.5876 4 10.9286 4L12.2143 4ZM7.07143 4C7.41242 4 7.73945 4.1317 7.98057 4.36612C8.22168 4.60054 8.35714 4.91848 8.35714 5.25L8.35714 12.75C8.35714 13.0815 8.22168 13.3995 7.98057 13.6339C7.73945 13.8683 7.41242 14 7.07143 14L5.78571 14C5.44472 14 5.11769 13.8683 4.87658 13.6339C4.63546 13.3995 4.5 13.0815 4.5 12.75L4.5 5.25C4.5 4.91848 4.63546 4.60054 4.87658 4.36612C5.11769 4.1317 5.44472 4 5.78571 4L7.07143 4Z"
        fill={color || 'currentColor'}
      />
    </SvgStyled>
  );
});
